import React from "react";
import Slider from "rc-slider";

import AibleStep from "containers/CreateWizard/AibleStep";

import styles from "./style.module.css";

export default class ChooseCounts extends React.PureComponent {
  handleUpdateSlider(step) {
    const { updateConversionGain, updateConversionCost, updateConversionMissed, updateConversionSaved } = this.props;

    if (step === 0) {
      updateConversionGain(1);
      updateConversionMissed(-1);
      updateConversionSaved(10);
      updateConversionCost(-10);
    } else if (step === 1) {
      updateConversionGain(1);
      updateConversionMissed(-1);
      updateConversionSaved(5);
      updateConversionCost(-5);
    } else if (step === 2) {
      updateConversionGain(1);
      updateConversionMissed(-1);
      updateConversionSaved(2);
      updateConversionCost(-2);
    } else if (step === 3) {
      updateConversionGain(1);
      updateConversionMissed(-1);
      updateConversionSaved(1);
      updateConversionCost(-1);
    } else if (step === 4) {
      updateConversionGain(2);
      updateConversionMissed(-2);
      updateConversionSaved(1);
      updateConversionCost(-1);
    } else if (step === 5) {
      updateConversionGain(5);
      updateConversionMissed(-5);
      updateConversionSaved(1);
      updateConversionCost(-1);
    } else if (step === 6) {
      updateConversionGain(10);
      updateConversionMissed(-10);
      updateConversionSaved(1);
      updateConversionCost(-1);
    }
  }

  calculateStep() {
    const { conversionGain, conversionCost } = this.props;

    let step = 0;

    if (conversionGain === 1 && conversionCost === -10) {
      step = 0;
    } else if (conversionGain === 1 && conversionCost === -5) {
      step = 1;
    } else if (conversionGain === 1 && conversionCost === -2) {
      step = 2;
    } else if (conversionGain === 1 && conversionCost === -1) {
      step = 3;
    } else if (conversionGain === 2 && conversionCost === -1) {
      step = 4;
    } else if (conversionGain === 5 && conversionCost === -1) {
      step = 5;
    } else if (conversionGain === 10 && conversionCost === -1) {
      step = 6;
    }

    return step;
  }

  renderSlider() {
    const { id, isContinuous, options, outcome, success } = this.props;

    const outcomeSuccess = outcome && success ? outcome + " = " + success : "Outcome = Success";

    const marks = isContinuous
      ? {
          0: "Impact of Underestimate ≥ 10x Impact of Overestimate",
          1: "Impact of Underestimate ≥ 5x Impact of Overestimate",
          2: "Impact of Underestimate ≥ 2x Impact of Overestimate",
          3: "Impact of Overestimate = Impact of Underestimate",
          4: "Impact of Overestimate ≥ 2x Impact of Underestimate",
          5: "Impact of Overestimate ≥ 5x Impact of Underestimate",
          6: "Impact of Overestimate ≥ 10x Impact of Underestimate"
        }
      : {
          0:
            "The Cost of incorrectly predicting when '" +
            outcomeSuccess +
            "' is > 10 times the Benefit of getting it right",
          1:
            "The Cost of incorrectly predicting when '" +
            outcomeSuccess +
            "' is > 5 times the Benefit of getting it right",
          2:
            "The Cost of incorrectly predicting when '" +
            outcomeSuccess +
            "' is > 2 times the Benefit of getting it right",
          3:
            "The Benefit of correctly predicting when '" +
            outcomeSuccess +
            "' is equal to the Cost of getting it wrong",
          4:
            "The Benefit of correctly predicting when '" +
            outcomeSuccess +
            "' is > 2 times the Cost of getting it wrong",
          5:
            "The Benefit of correctly predicting when '" +
            outcomeSuccess +
            "' is > 5 times the Cost of getting it wrong",
          6:
            "The Benefit of correctly predicting when '" +
            outcomeSuccess +
            "' is > 10 times the Cost of getting it wrong"
        };

    const step = this.calculateStep();

    const isLocked = options && options["lock"];

    return (
      <AibleStep
        id={id}
        bId={"costsSlider"}
        message={
          isContinuous
            ? "What is the impact of AI Overestimating " + outcome + " vs. Underestimating " + outcome + "?"
            : "What is the Benefit of AI predicting correctly vs. the Cost of getting it wrong?"
        }
        isBreak={true}
      >
        <div className={styles.sliderBody}>
          <div className={styles.sliderValue}>{marks[step]}</div>
          <div className={styles.sHolder}>
            <div className={styles.cost} style={{ paddingRight: "10px" }}>
              {isContinuous ? "Under" : "Cost"}
            </div>
            <Slider
              min={0}
              max={6}
              value={step}
              dots={true}
              onChange={isLocked ? () => {} : (val) => this.handleUpdateSlider(val)}
              className={styles.sliderHolder}
            />
            <div className={styles.cost} style={{ paddingLeft: "10px" }}>
              {isContinuous ? "Over" : "Benefit"}
            </div>
          </div>
        </div>
      </AibleStep>
    );
  }

  render() {
    const { isShow } = this.props;

    return <div className={styles.dataBody}>{this.renderSlider()}</div>;
  }
}
